export default __webpack_public_path__ + "static/media/iiconos-13.0aa7ef1b.png";